import { Link } from '@remix-run/react';
import { IconLockOpen } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useRoutePath } from '~/hooks/useRoutePath';

export default function AuthLeftPanel() {
  const routePath = useRoutePath();
  const { t } = useTranslation();

  return (
    <div className="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-0 order-lg-0">
      <div className="d-flex flex-column justify-content-center align-items-center bg-light rounded-4 h-100 p-3">
        <div className="text-center">
          <div className="mb-3">
            <IconLockOpen stroke={2} size={144} aria-hidden="true" />
          </div>
          <h2>{t('pages.login.no_account')}</h2>
          <Link to={routePath('register')} className="btn btn-link" id="register-here-button" rel="nofollow">
            {t('pages.login.register_here')}
          </Link>
        </div>
      </div>
    </div>
  );
}
